require("core-js/modules/es6.typed.float32-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var browser_1 = require("./browser");

var arrayConstructor = browser_1.isEdge ? Array : Float32Array;

function createNumberArray(n) {
  return new arrayConstructor(n);
}

exports.createNumberArray = createNumberArray;